var _rect, _rect2, _path, _circle, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 225,
    viewBox: "0 0 250 225",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 121,
    y: 107,
    width: 97.6544,
    height: 63.2157,
    rx: 4,
    transform: "rotate(-45 121 107)",
    fill: "#F8F8F8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 110.052,
    width: 97.6544,
    height: 63.2157,
    rx: 4,
    transform: "rotate(-45 102 110.052)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.464 89.6611C65.6885 89.6611 65.6885 83.6205 69.464 83.6205H101.931C105.707 83.6205 105.707 89.6611 101.931 89.6611H69.464ZM37.7531 50.3986C33.9776 50.3986 33.9776 45.114 37.7531 45.114H140.437C144.212 45.114 144.212 50.3986 140.437 50.3986H37.7531ZM3.02273 70.0295C-0.752774 70.0295 -0.752774 63.9889 3.02273 63.9889H120.807C125.337 63.9889 125.337 70.0295 120.807 70.0295H3.02273ZM113.257 105.515L172.904 46.6231C174.415 44.358 178.189 44.358 179.7 46.6231L214.43 81.3534C216.695 83.6185 216.695 86.638 214.43 88.1487L155.538 147.796C153.273 150.061 150.253 150.061 147.988 147.796L113.258 113.066C110.993 110.801 110.993 107.781 113.258 105.516L113.257 105.515ZM159.314 105.515L151.764 144.022L147.989 143.268L155.539 106.271L117.787 113.067L117.032 109.291L166.867 100.231L176.681 50.3964L180.457 51.151L172.907 88.9028L209.904 81.3531L210.658 85.1286L172.151 92.6783L169.886 103.249L159.315 105.514L159.314 105.515ZM110.991 103.25L170.638 44.358C173.658 40.5825 178.944 40.5825 181.963 44.358L216.694 79.0883C220.469 82.108 220.469 87.3941 216.694 91.1683L157.802 150.06C154.026 153.836 148.741 153.836 145.722 150.06L110.991 115.33C107.972 112.31 107.971 107.024 110.991 103.25Z",
    fill: "#585858"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 135,
    r: 40,
    fill: "#E7FCDC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M225 133.62V135C224.998 138.235 223.951 141.382 222.014 143.973C220.077 146.564 217.355 148.459 214.253 149.376C211.151 150.293 207.836 150.183 204.802 149.062C201.768 147.941 199.177 145.869 197.416 143.156C195.656 140.442 194.82 137.232 195.033 134.005C195.245 130.777 196.496 127.705 198.597 125.246C200.699 122.787 203.539 121.073 206.694 120.36C209.849 119.647 213.15 119.974 216.105 121.29",
    stroke: "#45941E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M225 123L210 138.015L205.5 133.515",
    stroke: "#45941E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSuccess);
export default __webpack_public_path__ + "static/media/EmailSuccess.7b797b976db7c38675f87b621bd265cc.svg";
export { ForwardRef as ReactComponent };